import { render, staticRenderFns } from "./AboutUsComponent.vue?vue&type=template&id=4fe46110&scoped=true"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js"
import style0 from "./AboutUsComponent.vue?vue&type=style&index=0&id=4fe46110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe46110",
  null
  
)

export default component.exports